export type EditorialPost = { status: string; published_at: string | null };
export function editorialTotals(posts: EditorialPost[], now = new Date()) {
  return posts.reduce((totals, post) => {
    if (post.status === "draft") totals.drafts++;
    else if (post.status === "published") {
      if (post.published_at && new Date(post.published_at) > now) totals.scheduled++;
      else totals.published++;
    }
    return totals;
  }, { published: 0, drafts: 0, scheduled: 0 });
}
export const canManagePlatform = (role: string | null) => role === "admin" || role === "superadmin";